import styled from "styled-components";

export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 200px repeat(5, 1fr);
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: none;
  }
`;

export const MachineCell = styled.div`
  padding: 16px;
  background-color: #f9f9f9;
  border-right: 1px solid #ddd;
  font-weight: 500;
`;

export const MachineName = styled.div`
  font-size: 1rem;
  margin-bottom: 4px;
`;

export const MachineInfo = styled.div`
  font-size: 0.8rem;
  color: #666;
`;